/* eslint-disable jsx-a11y/anchor-is-valid */
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import Footer from "../Footer/Footer";
import Resources from "./Resources";
import PositionedGraphBackground from "./GraphBackground/sizedIndex";
import Demo from "./Demo";
import TeamBio from "./TeamBio";
import "./index.css";
import ContactModal from "../ContactSales";
import GlueGraph from "./glueGraph";

const GlueLogo = ({ width = 160 }) => (
    <img
        src="/images/logo.svg"
        alt="Glue Logo"
        className="logo-img"
        width={width}
        height="auto"
    />
);

export default function Intro() {
    const [teamBio, setTeamBio] = useState({
        header: "Meet the team",
        members: []
    });
    const [pageDetails, setPageDetails] = useState({

        header: "What Our Platform Provides",

        featuresData: {

            features: [
                "Improved counterparty risk assessment",
                "Stronger AML regulatory compliance",
            ],

            identifiers: [
                "UEI",
                "CUSIP",
            ]
        }
    });
    const [isLoading, setIsLoading] = useState(true);
    const [demo, setDemoData] = useState({
        eyebrow: "GRAPH FIRST SEARCH ENGINE",
        title: "Explore the story behind your data.",
        description: "From tangled data to clear context...",
        linkText: "Explore more →",
        poster: "/poster.png",
        video: "/video.mp4"
    });

    const [heroData, setHeroData] = useState({
        title: "Turn Complex Data into Clear Decisions \n Discover Hidden Patterns",
        subtitle: "Explore hidden relationships in your data with interactive graph visualization",
        primaryBtnText: "Get started",
        outlineBtnText: "Explore Tool"
    });

    const handleDemoPlay = () => {
        // Analytics.logEvent("demo_played", { location: "Intro" });
    };


    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await fetch(
                    "https://5549ucvkb3.execute-api.us-east-2.amazonaws.com"
                );

                const data = await res.json();

                const body = typeof data.body === "string"
                    ? JSON.parse(data.body)
                    : data;

                if (body.hero) setHeroData(body.hero);

                // ✅ TEAM BIO FIX
                if (body.teamBio) {
                    setTeamBio({
                        header: body.teamBio.header || "Meet the team",
                        members: Array.isArray(body.teamBio.members)
                            ? body.teamBio.members
                            : Array.isArray(body.teamBio)
                                ? body.teamBio
                                : []
                    });
                }

                if (body.pageDetails) {

                    setPageDetails({

                        header:
                            body.pageDetails.header?.trim()
                            || "What Our Platform Provides",

                        featuresData: {

                            features:
                                body.pageDetails
                                    ?.featuresData
                                    ?.features || [],

                            identifiers:
                                body.pageDetails
                                    ?.featuresData
                                    ?.identifiers || []
                        }
                    });

                } else {

                    setPageDetails({

                        header:
                            "What Our Platform Provides",

                        featuresData: {

                            features: [
                                "Improved counterparty risk assessment",
                                "Stronger AML regulatory compliance",
                            ],

                            identifiers: [
                                "UEI",
                                "CUSIP",
                            ]
                        }
                    });
                }

                if (body.demo) setDemoData(body.demo);

            } catch (err) {
                console.error("Fetch Error:", err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, []);

    if (isLoading) {
        return (
            <div className="landing-container">
                <section className="hero">
                    <div className="skeleton-container">
                        <div className="skeleton skeleton-title" />
                        <div className="skeleton skeleton-subtitle" />

                        <div style={{ display: "flex", gap: "20px" }}>
                            <div className="skeleton skeleton-button" />
                            <div className="skeleton skeleton-button" />
                        </div>
                    </div>
                </section>
            </div>
        );
    }

    return (
        <div className="landing-container">
            {/* Navbar */}
            <header className="navbar">
                <div className="navbar-links">
                    <div className="logo">
                        <Link to="/" style={{ textDecoration: "none" }}>
                            <GlueLogo />
                        </Link>
                    </div>

                    <nav className="nav-links">
                        <a href="#demo">Demo</a>
                        <a href="#team">Team</a>
                        <Link to="/help" style={{ textDecoration: "none" }}>
                            <span className="login">Help</span>
                        </Link>
                        <Link to="/sales" style={{ textDecoration: "none" }}>
                            <span className="login" href="#pricing">Pricing</span>
                        </Link>

                    </nav>
                </div>

                <div className="actions">
                    <a
                        className="btn-primary-link"
                        href="https://datahub.glueid.com"
                    >
                        Login
                    </a>
                    <ContactModal triggerClass="btn-outline" />
                    <a
                        className="btn-primary-link"
                        href="https://datahub.glueid.com/signup"
                    >
                        Sign Up
                    </a>
                </div>
            </header>

            {/* Hero */}
            <section className="hero">
                <PositionedGraphBackground />

                <h1 className="hero-title" style={{ whiteSpace: 'pre-line' }}>
                    {heroData.title}
                </h1>
                <p className="hero-subtitle">
                    {heroData.subtitle}
                </p>

                {/* <div className="hero-buttons">
                    <Link to="/signup">
                        <button className="btn-primary large">{heroData.primaryBtnText || "Get started"}</button>
                    </Link>
                    <a href="#demo" className="btn-outline large" onClick={handleDemoPlay}>
                        {heroData.outlineBtnText || "Explore Tool"}
                    </a>
                </div> */}

                {/* <GlueIdExplainer/> */}

                <GlueGraph />

            </section>

            {/* Resources */}
            <section id="resources">
                <Resources pageDetails={pageDetails} />
            </section>

            {/* Demo */}
            <section id="demo">
                <Demo demoData={demo} handleDemoPlay={handleDemoPlay} />
            </section>

            {/* ✅ PRICING FIX */}
            {/* {pricePlans?.plans?.length > 0 && ( */}
            {/* <section id="pricing">
                <PricingPlans />
            </section> */}
            {/* )} */}

            {/* ✅ TEAM FIX */}
            {teamBio?.members?.length > 0 && (
                <section id="team">
                    <TeamBio
                        members={teamBio.members}
                        header={teamBio.header}
                    />
                </section>
            )}

            <Footer />
        </div>
    );
}